import { TableBody } from './table-body';
import { TableCell } from './table-cell';
import { TableHeader } from './table-header';
import { TableHeaderCell } from './table-header-cell';
import { TableResponsive } from './table-responsive';
import { TableRoot } from './table-root';
import { TableRow } from './table-row';
import { TableSortButton } from './table-sort-button';
import { TableSortIcon } from './table-sort-icon';

export const Table = {
  Responsive: TableResponsive,
  Root: TableRoot,
  Header: TableHeader,
  HeaderCell: TableHeaderCell,
  SortButton: TableSortButton,
  SortIcon: TableSortIcon,
  Body: TableBody,
  Row: TableRow,
  Cell: TableCell,
};
